const typography = {
  fontFamily: 'Oswald',
  body1: {
    fontWeight: 400,
    letterSpacing: 0.44
  },
  overline: {
    letterSpacing: 1.5,
    fontSize: 10
  },
  body2: {
    fontWeight: 100,
    fontSize: 12,
    letterSpacing: 0.44
  }
}

export default typography
